import { HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { getSessionId } from '../helpers/storageUtils';
import { TokenService } from '../shared/services/token.service';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  router = inject(Router);
  tokenService = inject(TokenService);
  SESSION_ID = getSessionId().toString();
  constructor() {}

  public getHeaders(sessionId: string): HttpHeaders {
    return new HttpHeaders({
      Accept: '*/*',
      Authorization: `Bearer ${this.tokenService.getToken()}`,
      session_id: sessionId || this.SESSION_ID,
      // client_id: environment.GENERAL_CLIENT_ID,
    });
  }

  handleredirect(codAsesor: string, url: string, params?: Record<string, any>): void {
    const queryParams = params?.['queryParams'] || {};
    if (codAsesor === undefined || codAsesor === '') {
      this.router.navigate([url], params);
    } else {
      this.router.navigate([url], {
        queryParams: { codigoAsesor: codAsesor, ...queryParams },
      });
    }
  }
}
